import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Routing = withSafeSuspense(
  lazy(
    async () => ({ default: (await import('./routing')).Routing })
  )
)
